// Actions
export const PROPERTIES__GET_PROPERTIES_AND_SCHEDULES = 'PROPERTIES__GET_PROPERTIES_AND_SCHEDULES';
export const PROPERTIES__ADD_PROPERTY = 'PROPERTIES__ADD_PROPERTY';
export const PROPERTIES__UPDATE_PROPERTY_INFO = 'PROPERTIES__UPDATE_PROPERTY_INFO';
export const PROPERTIES__GET_SERVICE_PROMOS = 'PROPERTIES__GET_SERVICE_PROMOS';
export const PROPERTIES__GET_SERVICE_PRICING = 'PROPERTIES__GET_SERVICE_PRICING';
export const PROPERTIES__GET_ELIGIBLE_PROS_FOR_REDISTRIBUTION =
  'PROPERTIES__GET_ELIGIBLE_PROS_FOR_REDISTRIBUTION';
export const PROPERTIES__REDISTRIBUTE_PRO = 'PROPERTIES__REDISTRIBUTE_PRO';
// Getters
export const PROPERTIES__GET_PROPERTY_ID_FOR_ORDER_SERVICES =
  'PROPERTIES__GET_PROPERTY_ID_FOR_ORDER_SERVICES';
export const PROPERTIES__PROPERTIES_IN_ARRAY = 'PROPERTIES__PROPERTIES_IN_ARRAY';
export const PROPERTIES__PROPERTIES_IN_ARRAY_WITH_ACTIVE_MOWING =
  'PROPERTIES__PROPERTIES_IN_ARRAY_WITH_ACTIVE_MOWING';
export const PROPERTIES__SELECTED_PROPERTY = 'PROPERTIES__SELECTED_PROPERTY';
export const PROPERTIES__HAS_MULTIPLE_PROPERTIES = 'PROPERTIES__HAS_MULTIPLE_PROPERTIES';
export const PROPERTIES__GET_CUSTOMER_LEAD_BY_ID = 'PROPERTIES__GET_CUSTOMER_LEAD_BY_ID';
export const PROPERTIES__GET_FIRST_HIRED_PRO_NEEDING_DETAILS =
  'PROPERTIES__GET_FIRST_HIRED_PRO_NEEDING_DETAILS';
// Mutations
export const PROPERTIES__RESET = 'PROPERTIES__RESET';
export const PROPERTIES__MUTATE_PROPERTIES = 'PROPERTIES__MUTATE_PROPERTIES';
export const PROPERTIES__MUTATE_PROPERTY = 'PROPERTIES__MUTATE_PROPERTY';
export const PROPERTIES__MUTATE_SERVICE_PROMOS = 'PROPERTIES__MUTATE_SERVICE_PROMOS';
export const PROPERTIES__MUTATE_LOADING_STATUS = 'PROPERTIES__MUTATE_LOADING_STATUS';
export const PROPERTIES__MUTATE_ELIGIBLE_PROS_FOR_REDISTRIBUTION =
  'PROPERTIES__MUTATE_ELIGIBLE_PROS_FOR_REDISTRIBUTION';
export const PROPERTIES__MUTATE_APPLICATION_REVIEW_PROPERTY_ID =
  'PROPERTIES__MUTATE_APPLICATION_REVIEW_PROPERTY_ID';
export const PROPERTIES__CAN_CANCEL_MOWING_SERVICES = 'PROPERTIES__CAN_CANCEL_MOWING_SERVICES';
